import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import AnswersReadable from "@/components/AnswersReadable";

export default function AdminPrint() {
    const { qid } = useParams();
    const [params] = useSearchParams();
    const mode = params.get("mode") === "advisor" ? "advisor" : "client";
    const [q, setQ] = useState(null);
    const [err, setErr] = useState(null);

    useEffect(() => {
        api.get(`/admin/questionnaires/${qid}`)
            .then((r) => setQ(r.data))
            .catch((e) => setErr(formatApiError(e)));
    }, [qid]);

    if (err) return <div className="p-8 text-red-700">Erreur : {err}</div>;
    if (!q) return <div className="p-8">Chargement…</div>;

    const c = q.contact || {};
    // Backend hydrates full mattress data (name, adequation score, price) in
    // `recommendation_details`. `recommendation` alone only carries ids.
    const details = q.recommendation_details || {};
    const primary = details.primary || {};
    const alt = details.alternative || {};
    const primaryScore = primary?.adequation?.score;
    const altScore = alt?.adequation?.score;
    const reasons = details.personalized_reasons || q.reasons || [];
    const dt = q.created_at ? new Date(q.created_at).toLocaleString("fr-FR") : "";

    return (
        <div className="print-root" style={{
            background: "#fff", color: "#222", fontFamily: "system-ui, sans-serif",
            padding: "20px", maxWidth: "800px", margin: "0 auto",
        }} data-testid="admin-print-page">
            <div className="print-actions" style={{ display: "flex", gap: 12, marginBottom: 24 }}>
                <button onClick={() => window.print()} data-testid="print-btn"
                    style={{ padding: "12px 20px", background: "#2A84C8", color: "#fff",
                             border: "none", borderRadius: 12, fontSize: 16, cursor: "pointer" }}>
                    Imprimer
                </button>
                <button onClick={() => window.close()}
                    style={{ padding: "12px 20px", background: "#eee", color: "#333",
                             border: "none", borderRadius: 12, fontSize: 16, cursor: "pointer" }}>
                    Fermer
                </button>
            </div>

            <h1 style={{ fontSize: 24, margin: "0 0 6px" }}>
                {mode === "advisor" ? "Fiche conseiller" : "Résultat client"} — Le Petit Matelassier
            </h1>
            <div style={{ fontSize: 14, color: "#666", marginBottom: 20 }}>{dt}</div>

            {mode === "advisor" && (
                <>
                    <h2 style={{ fontSize: 16, marginTop: 24, marginBottom: 8, borderBottom: "1px solid #eee", paddingBottom: 6 }}>
                        Coordonnées
                    </h2>
                    <div style={{ fontSize: 14 }}>
                        {c.prenom} {c.nom}<br />
                        Téléphone : {c.telephone || "—"}<br />
                        E-mail : {c.email || "—"}
                    </div>
                </>
            )}

            <h2 style={{ fontSize: 16, marginTop: 24, marginBottom: 8, borderBottom: "1px solid #eee", paddingBottom: 6 }}>
                Profil
            </h2>
            <div style={{ fontSize: 14 }}>{q.profile?.profile_label || "—"}</div>

            <h2 style={{ fontSize: 16, marginTop: 24, marginBottom: 8, borderBottom: "1px solid #eee", paddingBottom: 6 }}>
                Recommandation
            </h2>
            <div style={{ fontSize: 14 }}>
                <strong>Prioritaire :</strong> {primary.name || "—"}
                {primaryScore != null && ` — ${primaryScore}%`}
                {alt.name && (<><br /><strong>Alternative :</strong> {alt.name}{altScore != null && ` — ${altScore}%`}</>)}
            </div>

            {reasons.length > 0 && (
                <>
                    <h2 style={{ fontSize: 16, marginTop: 24, marginBottom: 8, borderBottom: "1px solid #eee", paddingBottom: 6 }}>
                        Principales raisons
                    </h2>
                    <ul style={{ fontSize: 14, paddingLeft: 20 }}>
                        {reasons.map((r, i) => (<li key={i} style={{ marginBottom: 4 }}>{r}</li>))}
                    </ul>
                </>
            )}

            {mode === "advisor" && (
                <>
                    <h2 style={{ fontSize: 16, marginTop: 24, marginBottom: 8, borderBottom: "1px solid #eee", paddingBottom: 6 }}>
                        Réponses détaillées
                    </h2>
                    <AnswersReadable answers={q.answers} />
                </>
            )}

            <div style={{ marginTop: 40, fontSize: 12, color: "#888", textAlign: "center" }}>
                Le Petit Matelassier — La Ciotat
            </div>

            <style>{`
                @page { size: A4; margin: 15mm; }
                @media print {
                    .print-actions { display: none !important; }
                    body { background: #fff !important; }
                }
            `}</style>
        </div>
    );
}
